import { Api, CookieService } from "./Services";
import { imagesFolder } from "./Api";

class Config {
	static gamesLoc = "/v1.0/games_engine/navigate.php";
	static remoteLoc = "/v1.0/games_engine/remote-controller.html";
	static imagesFolder = imagesFolder;
	static maxKids = 2;
	static SHOW_SHOP = 0;
	static CHARTS2_POPUP = 0;
	static CHARTS2_POPUP_LINK = 0;
	static STRIPE_SUCCESS_REDIRECT_SECONDS = 5;
	static isRemoteController = 0;
	static REMOTE_CONTROLLER_ACTIVATED = 0;
	static CHECKOUT_METHOD = 0;
	static STATUS_APP = 0;
	
	static async loadConfig() {
		this.isRemoteController = window.location.search.includes("isRemoteController=1");
		if (sessionStorage.getItem("isRemoteController")) {
			this.isRemoteController = 1;
		}
		if (this.isRemoteController) {
			sessionStorage.setItem("isRemoteController", 1);
		}

		const urlParams = new URLSearchParams(window.location.search);
		const statusApp = urlParams.get('statusApp');
		if(statusApp)	{
			CookieService.setCookie("statusApp", statusApp);
			sessionStorage.setItem("statusApp", statusApp);
			this.STATUS_APP = statusApp;
		}
		else if (sessionStorage.getItem("statusApp")) {
			this.STATUS_APP = sessionStorage.getItem("statusApp");
		}

		// console.log(this.isRemoteController);
		let res = await Api.getConfig();

		if (res.config) {
			let langId = CookieService.getCookie("info[lang_id]");
			if (!langId) {
				CookieService.setCookie("info[lang_id]", res.config.default_lang);
			}
			this.langId = langId || res.config.default_lang;

			for (let [key, value] of Object.entries(res.config)) {
				this[key] = value;
			}
			if (!this.REMOTE_CONTROLLER_ACTIVATED) {
				this.isRemoteController = 0;
			}
		}
	}

}


export default Config;